import { render, staticRenderFns } from "./EditAddonModal.vue?vue&type=template&id=a9bee796&scoped=true&"
import script from "./EditAddonModal.vue?vue&type=script&lang=js&"
export * from "./EditAddonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bee796",
  null
  
)

export default component.exports